import { useCallback } from "react";
import { useAnalyticsContext } from "../context/AnalyticsProvider";
import { cleanEventParams } from "../events/analyticsEvents";

/**
 * The one hook components should use to fire analytics. Pair event names
 * with the constants in ../events/analyticsEvents (ANALYTICS_EVENTS) rather
 * than hardcoding strings.
 *
 * @example
 * const { trackEvent } = useAnalytics();
 * trackEvent(ANALYTICS_EVENTS.FEATURE.KEYWORD_SEARCH, { keyword, platform });
 */
export const useAnalytics = () => {
  const { analytics } = useAnalyticsContext();

  const trackEvent = useCallback(
    (name, params) => analytics.trackEvent(name, cleanEventParams(params)),
    [analytics]
  );

  const trackPageView = useCallback(
    (path, title) => analytics.trackPageView(path, title),
    [analytics]
  );

  const setUser = useCallback(userId => analytics.setUser(userId), [analytics]);

  const setUserProperties = useCallback(
    properties => analytics.setUserProperties(cleanEventParams(properties)),
    [analytics]
  );

  return { trackEvent, trackPageView, setUser, setUserProperties };
};

export default useAnalytics;
